import { useSearchParams, useParams } from 'react-router-dom';

const useOrderVideoParams = () => {
  const [searchParams] = useSearchParams();
  const { id: orderId } = useParams();
  const videoId = searchParams.get("videoId");

  return { orderId, videoId };
};

export default useOrderVideoParams;
